import React, { Suspense } from "react"
import { Navigate, Route, Routes as RouterRoutes } from "react-router-dom"

const ViewPrivate = React.lazy(() => import("./PrivateRouter"))
const ViewPublic = React.lazy(() => import("./PublicRouter"))
const ViewOrgAdminOnboarding = React.lazy(() => import("../views/app/onboarding") as Promise<{ default: React.ComponentType<any> }>)
const ViewAdminSurveyOld = React.lazy(() => import("../views/public/survey"))
const ViewError = React.lazy(() => import("../views/errorView"))
const ViewNotFoundError = React.lazy(() => import("../views/notFoundView"))
const ViewForbidden = React.lazy(() => import("../views/forbiddenView"))

const Routes: React.FC<any> = () => (
  <Suspense fallback={<div className='loading' />}>
    <RouterRoutes>
      <Route path='/app/organizations/:organizationId/onboarding' element={<ViewOrgAdminOnboarding />} />
      <Route path='/app/*' element={<ViewPrivate />} />
      <Route path='/public/*' element={<ViewPublic />} />
      <Route path='/admin/survey/:token' element={<ViewAdminSurveyOld />} />
      <Route path='/forbidden' element={<ViewForbidden />} />
      <Route path='/unknown-error' element={<ViewError />} />
      <Route path='/error' element={<ViewNotFoundError />} />
      <Route path='*' element={<Navigate to='/public' replace />} />
    </RouterRoutes>
  </Suspense>
)

export default Routes
